import { render, staticRenderFns } from "./toggle-content.vue?vue&type=template&id=263bddb8&"
import script from "./toggle-content.vue?vue&type=script&lang=js&"
export * from "./toggle-content.vue?vue&type=script&lang=js&"
import style0 from "./toggle-content.vue?vue&type=style&index=0&id=263bddb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports